import HttpException from './HttpException';

export default class ValidationHttpException extends HttpException {
    name = 'ValidationHttpException';

    shouldBeReported = false;

    constructor(
        response: Response,
        protected errors: Record<string, string[]>,
        message: string
    ) {
        super(response, message);
    }

    getValidationErrors() {
        return this.errors;
    }
}
